import React from 'react';
import { Link, Redirect } from 'react-router-dom';
import {
	Card, Row, Col, Form, Input, Button, Select, Spin, message,
} from 'antd';
import {
	SaveOutlined, ArrowLeftOutlined, SignatureOutlined,
} from '@ant-design/icons';
import { connect } from 'react-redux';
import {
	initHandler, ajaxViewHandler, ajaxHandler, setConfig,
} from '../../store/actions';
import Config from '../../Config';
import { Helmet } from 'react-helmet';
import ErrorAlertModal from '../../components/ErrorAlertModal';

const configClass = {
	title : 'Form Tanda Tangan Laporan',
	apiUrl: {
		data      : 'master/api/ttd-laporan/',
		kabupaten : 'master/api/kabupaten/',
	},
	pageUrl: { data: '/admin/tanda_tangan_laporan' },
};

const PERAN_OPTIONS = [
	{ value: 'kepala_upt',     label: 'Kepala UPTPPD Samsat' },
	{ value: 'polda',          label: 'Kasi STNK Ditlantas Polda Kalteng' },
	{ value: 'jr',             label: 'Penanggung Jawab PT Jasa Raharja' },
	{ value: 'kasi_tu',        label: 'Kasi TU' },
	{ value: 'uptppd',         label: 'Kasi Penetapan UPTPPD Samsat' },
	{ value: 'kasi_pelaporan', label: 'Kasi Pelaporan' },
	{ value: 'bendahara',      label: 'Bendahara Penerima' },
];

const config = new Config();

class FormTandaTanganLaporan extends React.Component {
	formRef = React.createRef();

	constructor(props) {
		super(props);
		this.state = {
			errMsg           : '',
			errTitle         : '',
			loadingData      : false,
			loadingButton    : false,
			loadingKabupaten : false,
			listKabupaten    : [],
			isRedirect       : false,
			editId           : props.match && props.match.params && props.match.params.id ? props.match.params.id : null,
			isMobile         : window.innerWidth <= 768,
		};
	}

	UNSAFE_componentWillMount() {
		this.props.initHandler();
	}

	componentDidMount() {
		const { editId } = this.state;
		if (editId) {
			// serialkan: getDetail berjalan setelah getKabupaten selesai
			// supaya this.props.responseMsg tidak saling tumpang-tindih
			this.getKabupaten()
				.then(() => this.getDetail(editId))
				.catch(() => this.getDetail(editId));
		} else {
			this.getKabupaten();
		}
		this._handleResize = () => this.setState({ isMobile: window.innerWidth <= 768 });
		window.addEventListener('resize', this._handleResize);
	}

	componentWillUnmount() {
		window.removeEventListener('resize', this._handleResize);
	}

	getKabupaten() {
		this.setState({ loadingKabupaten: true });
		return this.props.ajaxViewHandler('get', configClass.apiUrl.kabupaten + '?limit=500')
			.then(() => {
				if (this.props.isSuccess) {
					const res = this.props.responseMsg;
					const list = res.results || (Array.isArray(res) ? res : []);
					this.setState({ listKabupaten: list });
				}
				this.setState({ loadingKabupaten: false });
			})
			.catch(() => this.setState({ loadingKabupaten: false }));
	}

	async getDetail(id) {
		this.setState({ loadingData: true });
		this.props.ajaxViewHandler('get', configClass.apiUrl.data + id + '/')
			.then(() => {
				if (this.props.isSuccess) {
					const d = this.props.responseMsg;
					// loadingData: false dulu agar form mount kembali,
					// baru isi nilai di callback setState saat formRef sudah tersedia
					this.setState({ loadingData: false }, () => {
						if (this.formRef.current) {
							this.formRef.current.setFieldsValue({
								kabupaten: d.kabupaten,
								peran    : d.peran,
								nama     : d.nama,
								jabatan  : d.jabatan,
								nip      : d.nip,
							});
						}
					});
				} else {
					this.setState({ loadingData: false });
				}
			})
			.catch(() => this.setState({ loadingData: false }));
	}

	handleSubmit = (values) => {
		this.setState({ loadingButton: true });
		const { editId } = this.state;
		const method = editId ? 'put' : 'post';
		const url    = editId
			? configClass.apiUrl.data + editId + '/'
			: configClass.apiUrl.data;

		const payload = {
			...values,
			jabatan: values.jabatan != null ? values.jabatan : '',
			nip    : values.nip != null ? values.nip : '',
		};

		message.loading({ content: 'Menyimpan...', key: 'toast' });
		this.props.ajaxHandler(method, url, payload)
			.then(() => {
				this.setState({ loadingButton: false });
				if (this.props.isSuccess) {
					message.success({ content: 'Data berhasil disimpan', duration: 2, key: 'toast' });
					this.setState({ isRedirect: true });
				} else {
					message.error({ content: 'Gagal menyimpan data', duration: 2, key: 'toast' });
					this.setState({ errTitle: 'Gagal simpan', errMsg: this.props.responseMsg });
				}
			})
			.catch(() => {
				this.setState({ loadingButton: false });
				message.error({ content: 'Kesalahan jaringan', duration: 2, key: 'toast' });
			});
	}

	render() {
		if (this.state.isRedirect) return <Redirect to={configClass.pageUrl.data} />;

		const { loadingData, loadingButton, editId, isMobile } = this.state;

		return (
			<div>
				<Helmet>
					<title>{configClass.title + ' | ' + config.get_site_info().name}</title>
				</Helmet>

				<Card
					style={{ borderRadius: 14, border: 'none', boxShadow: '0 4px 20px rgba(15,40,71,0.13)', marginBottom: 16 }}
					bodyStyle={{ padding: 0 }}
				>
					<div style={{
						background  : 'linear-gradient(135deg, #0f2847 0%, #1e4d8a 60%, #0a3d6b 100%)',
						borderRadius: '14px 14px 0 0',
						padding     : isMobile ? '14px 16px' : '20px 28px',
						display: 'flex', alignItems: 'center', gap: 14,
					}}>
						<div style={{
							width: isMobile ? 36 : 48, height: isMobile ? 36 : 48, borderRadius: 12,
							background: 'rgba(255,255,255,0.15)',
							display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: isMobile ? 16 : 22,
							flexShrink: 0,
						}}>
							<SignatureOutlined style={{ color: '#fff' }} />
						</div>
						<div>
							<div style={{ color: '#fff', fontWeight: 700, fontSize: isMobile ? 14 : 17 }}>
								{editId ? 'Edit' : 'Tambah'} Tanda Tangan Laporan
							</div>
							{!isMobile && (
								<div style={{ color: 'rgba(255,255,255,0.7)', fontSize: 13, marginTop: 2 }}>
									TTD per Kabupaten/Kota untuk Berita Acara Batal SKPD
								</div>
							)}
						</div>
					</div>

					<div style={{ padding: isMobile ? '16px 14px' : '24px 28px' }}>
						<ErrorAlertModal
							visible={this.state.errMsg !== ''}
							title={this.state.errTitle}
							error={this.state.errMsg}
							onClose={() => this.setState({ errTitle: '', errMsg: '' })}
						/>

						{loadingData ? (
							<div style={{ textAlign: 'center', padding: 48 }}><Spin /></div>
						) : (
							<Form
								ref={this.formRef}
								layout="vertical"
								onFinish={this.handleSubmit}
								style={{ maxWidth: isMobile ? '100%' : 560 }}
							>
								<Form.Item
									label="Kabupaten / Kota"
									name="kabupaten"
									rules={[{ required: true, message: 'Kabupaten / Kota wajib dipilih' }]}
								>
									<Select
										showSearch
										placeholder="Pilih Kabupaten / Kota"
										optionFilterProp="children"
										loading={this.state.loadingKabupaten}
										style={{ width: '100%' }}
									>
										{this.state.listKabupaten.map(k => (
											<Select.Option key={k.id} value={k.id}>
												{k.name}
											</Select.Option>
										))}
									</Select>
								</Form.Item>

								<Form.Item
									label="Peran"
									name="peran"
									rules={[{ required: true, message: 'Peran wajib dipilih' }]}
								>
									<Select placeholder="Pilih peran TTD">
										{PERAN_OPTIONS.map(o => (
											<Select.Option key={o.value} value={o.value}>
												{o.label}
											</Select.Option>
										))}
									</Select>
								</Form.Item>

								<Form.Item
									label="Nama"
									name="nama"
									rules={[{ required: true, message: 'Nama wajib diisi' }]}
								>
									<Input placeholder="Nama lengkap pejabat" />
								</Form.Item>

								<Form.Item label="Jabatan" name="jabatan">
									<Input placeholder="Jabatan (opsional, pakai default jika kosong)" />
								</Form.Item>

								<Form.Item label="NIP" name="nip">
									<Input placeholder="NIP (opsional)" />
								</Form.Item>

								<div style={{
									marginTop: 16,
									display: 'flex',
									flexDirection: isMobile ? 'column' : 'row',
									gap: 10,
								}}>
									<Button
										type="primary"
										htmlType="submit"
										loading={loadingButton}
										icon={<SaveOutlined />}
										style={{
											background: 'linear-gradient(135deg, #0f2847, #1e4d8a)',
											border: 'none', borderRadius: 8, fontWeight: 600, height: 40,
											width: isMobile ? '100%' : 'auto',
										}}
									>
										Simpan
									</Button>
									<Link to={configClass.pageUrl.data} style={isMobile ? { display: 'block' } : {}}>
										<Button icon={<ArrowLeftOutlined />} style={{ borderRadius: 8, height: 40, width: isMobile ? '100%' : 'auto' }}>
											Kembali
										</Button>
									</Link>
								</div>
							</Form>
						)}
					</div>
				</Card>
			</div>
		);
	}
}

const mapStateToProps = (state) => state.configReducers;

export default connect(mapStateToProps, {
	initHandler, setConfig, ajaxViewHandler, ajaxHandler,
})(FormTandaTanganLaporan);
